module.exports = __webpack_public_path__ + "img/73.2c2e9b10.jpg";